import React, { useState } from 'react'

import { SvgImage } from 'components/SvgImage'

import copyIcon from 'assets/images/sprite/copy-icon.svg'

import { StyledClipboardField as S } from './ClipboardField.styles'

type TProps = {
  tooltipText: string
  value: string
}

export const ClipboardField: React.FC<TProps> = ({ tooltipText, value }) => {
  const [isTextCopied, setIsTextCopied] = useState(false)

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setIsTextCopied(true)
        setTimeout(() => setIsTextCopied(false), 1500)
      })
      .catch((error) => console.error('Error: copy failed', error))
  }

  return (
    <S.Container title="Click to copy" onClick={() => copyToClipboard(value)}>
      <S.Tooltip $isVisible={isTextCopied}>{tooltipText}</S.Tooltip>
      <p>{value}</p>

      <SvgImage svg={copyIcon} width={24} />
    </S.Container>
  )
}
